<t4-header></t4-header>
<t4-container [isLoading]="isLoading">
  <t4-data-table #tblCustomers [rawData]="customersData" matSortActive="DeliveryAddressCustomerName" matSortDirection="asc" headline="{{ 'TO.Customers.Headline' | translate : 'Customers' }}" [cacheTimeInMinutes]="720" [autoGenerateColumns]="false" matSort (itemClicked)="gotoCustomer($event)" [filterFields]="['DeliveryAddressCustomerName', 'DeliveryAddress', 'DeliveryCity', 'XalAccountNo', 'CustomerNumber', 'Chain', 'Country', 'TrailerList', 'RentalOrderList', 'SalesRepId','ServicePartner','RepairPartner']">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef style="max-width: 75px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px;"><mat-icon style="color: red;" *ngIf="row.IsDeleted">block</mat-icon><mat-icon *ngIf="!row.IsDeleted">business</mat-icon></mat-cell>
    </ng-container>
    <ng-container matColumnDef="XalAccountNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 100px;">{{ 'TO.Customers.Table_Customer no' |translate : 'Customer No' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 100px;">{{ row.XalAccountNo }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryAddressCustomerName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_Name' |translate : 'Name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryAddressCustomerName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryAddress">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_Address' |translate : 'Address' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryAddress }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="DeliveryCity">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Customers.Table_City' |translate : 'City' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DeliveryCity }}</mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
